import { Text } from '@mantine/core';
import { ReactElement } from 'react';

/** Nothing to say in this cell — never a blank one, which reads as missing data. */
export function EmptyCell(): ReactElement {
  return (
    <Text size="sm" c="dimmed">
      —
    </Text>
  );
}
